module.exports = __webpack_public_path__ + "img/massey-ferguson.4e5c6c3e.svg";